import { isMedleyProduct, isThemedBoxProduct } from "@helpers/products/types";

import styles from "./main.module.scss";

const BoxItemsInfo = ({ intent }) => {
  const isThemedBox = isThemedBoxProduct(intent);
  const isMedley = isMedleyProduct(intent);

  if (!isThemedBox && !isMedley) return null;

  return (
    <span className={styles.noteText}>
      <b>Note:</b>
      <i>
        The number of items will vary depending on the gift budget. Some individual items may differ
        from photos and similar products will be provided. Photo is based on a{" "}
        {isMedley ? "large" : "small"} box.
      </i>
    </span>
  );
};

export default BoxItemsInfo;
